import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import {
  get,
  omit,
  omitBy,
  keys,
  isEmpty,
  includes,
  filter,
  isArray,
  difference,
  map,
  find
} from 'lodash'
import { Button, Icon } from 'semantic-ui-react'

import { createDoctorLicense } from '../graphql/queries'
import { ModalBackground } from './common'
import PreLoader from './common/preloader'
import { STATES } from '../constants'
import { AppContext } from '../context/app'
import gql from '../utils/graphql'

const Form = styled.form`
  width: 90%;
  max-width: 500px;
  max-height: 650px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
`

const Title = styled.h2`
  font-size: 1.25rem;
`

const Licenses = styled.div`
  max-height: 500px;
  overflow: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 2rem;
  padding: 1rem;
`
const License = styled.div`
  display: flex;
  justify-content: space-between;
`

const State = styled.p``

const LicenseInput = styled.input.attrs({
  placeholder: '#'
})`
  margin-right: 0.5rem;
`

const Delete = styled(Icon).attrs({
  size: 'small',
  name: 'times'
})`
  cursor: pointer;
`

const InputGroup = styled.div``

const Submit = styled(Button).attrs({
  type: 'submit'
})`
  align-self: center;
`

const LicensesForm = () => {
  const {
    sessionId,
    user,
    updateLicenses,
    operatingStates,
    licenses: currentLicenses
  } = useContext(AppContext)
  const [states, setStates] = useState()
  const [licenses, setLicenses] = useState({})
  const [loading, setLoading] = useState(false)

  const remove = state => {
    setLicenses(omit(licenses, state))
    setStates(states.filter(({ alias }) => alias !== state))
  }

  const updateLiceneses = (license, key) => {
    const update = {
      ...licenses,
      [key]: license
    }
    setLicenses(update)
  }

  const saveLicenses = async e => {
    e.preventDefault()
    setLoading(true)
    const toSave = omitBy(licenses, number => number === '')
    const toSubmit = keys(toSave).map(state => ({
      state,
      license: get(toSave, state)
    }))

    const licensesCreated = get(
      await gql({
        operation: createDoctorLicense,
        path: 'createDoctorLicense',
        variables: {
          oktaId: get(user, 'oktaId'),
          sessionId,
          licenses: JSON.stringify(toSubmit)
        }
      }),
      'body'
    )
    if (!isEmpty(licensesCreated)) {
      updateLicenses()
    }
  }

  useEffect(() => {
    if (!isEmpty(operatingStates)) {
      setStates(
        difference(
          filter(STATES, ({ stateId }) => includes(operatingStates, stateId)),
          map(currentLicenses, license =>
            find(STATES, ({ alias }) => alias === get(license, 'state'))
          )
        )
      )
    }
  }, [operatingStates, currentLicenses])

  if (!isEmpty(operatingStates) && !isEmpty(states)) {
    return (
      <ModalBackground>
        <Form onSubmit={saveLicenses}>
          <Title>Please enter your license number(s) below:</Title>
          <Licenses>
            {isArray(states) &&
              states.map(({ name, alias }) => (
                <License key={alias}>
                  <State>{name}</State>
                  <InputGroup>
                    <LicenseInput
                      type="text"
                      value={get(licenses, alias, '')}
                      onChange={e => {
                        updateLiceneses(get(e, 'target.value'), alias)
                      }}
                    />
                    <Delete onClick={() => remove(alias)} />
                  </InputGroup>
                </License>
              ))}
          </Licenses>
          {!loading ? <Submit primary>Save</Submit> : <PreLoader />}
        </Form>
      </ModalBackground>
    )
  }
  return <></>
}

export default LicensesForm
